import {Injectable} from '@angular/core'


@Injectable({
  providedIn: 'root',
})
export class PrintService {

  constructor() {
  }


  printPdf(blob: Blob, fileName: string = 'document.pdf'): void {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    if (isSafari) {
      this.printUsingIframe(blob, fileName)
    } else {
      this.printUsingBlobUrl(blob, fileName)
    }
  }


  private printUsingBlobUrl(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob)
    const printWindow = window.open(url, '_blank')

    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
        // Optional: revoke URL after some time
        setTimeout(() => URL.revokeObjectURL(url), 1000)
      })
    } else {
      // fallback: download
      this.downloadBlob(blob, fileName)
    }
  }


  private printUsingIframe(blob: Blob, fileName: string): void {
    const blobUrl = URL.createObjectURL(blob)
    const html = `
      <html lang="de">
        <head><title>Print PDF</title></head>
        <body style="margin:0">
          <iframe src="${blobUrl}" style="width:100%; height:100vh; border:none"></iframe>
          <script>
            const iframe = document.querySelector('iframe')
            iframe.onload = function () {
              setTimeout(() => {
                iframe.contentWindow.focus()
                iframe.contentWindow.print()
              }, 100)
            }
          </script>
        </body>
      </html>
    `

    const printWindow = window.open('', '_blank')
    if (printWindow) {
      printWindow.document.open()
      printWindow.document.write(html)
      printWindow.document.close()
    } else {
      // fallback
      this.downloadBlob(blob, fileName)
    }
  }


  private downloadBlob(blob: Blob, fileName: string = 'document.pdf') {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.click()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }
}
